import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-40 bg-walnut-deep" data-id="element-201" data-mp="8biavi7w14qi">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-2.5 text-sm" data-id="element-202" data-mp="3hx8zf36bqm1">
        <p className="truncate text-sand" data-id="element-203" data-mp="3unyp421zxaej">
          <span className="mr-2 font-bold text-brass" data-id="element-204" data-mp="3umxc3s1f6du6">PROMO</span>
          <span className="hidden sm:inline" data-id="element-205" data-mp="3qo6dthl7wq5h">
            Le Pack Prof de Piano + 5 bonus exclusifs — seulement 27 USD. L'offre se termine ce soir.
          </span>
          <span className="sm:hidden" data-id="element-206" data-mp="3goz3l39s5bml">Pack + 5 bonus — 27 USD</span>
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-207" data-mp="3gr1xhye1zowl">
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sand/70" data-id="element-208" data-mp="3brfjvnubc6n9">
            Fin dans
          </span>
          <span className="font-semibold tabular-nums text-linen" data-id="element-209" data-mp="1evhvxzlngaru">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}